import { Button } from '~/components/button'
import { Link } from '~/components/link'
import {
  DISPLAY_NAME,
  type SnackbarScopedProps,
  useSnackbarContext,
} from '../../snackbar'
import {
  SnackbarFooterButtonVariants,
  SnackbarFooterLinkVariants,
} from './snackbar-footer.styles'

type SnackbarFooterProps = {}
export const SnackbarFooter = (props: SnackbarFooterProps) => {
  const { __scopeSnackbar } = props as SnackbarScopedProps<SnackbarFooterProps>

  const { onClickFooter, layout, buttonLabel, setPaused } = useSnackbarContext(
    DISPLAY_NAME,
    __scopeSnackbar
  )

  const handlePause = () => {
    setPaused(true)
  }
  const handleRestart = () => {
    setPaused(false)
  }

  if (layout === undefined) {
    return
  }

  if (layout === 'with-link') {
    return (
      <div
        className={SnackbarFooterLinkVariants({})}
        data-testid="snackbar-footer-link"
        onMouseDown={handlePause}
        onMouseUp={handleRestart}
      >
        <Link.Root icon size="ml" onClick={onClickFooter}>
          {buttonLabel === '' || !buttonLabel ? 'Link' : buttonLabel}
        </Link.Root>
      </div>
    )
  }
  return (
    <div
      className={SnackbarFooterButtonVariants({})}
      data-testid="snackbar-footer-button"
      onMouseDown={handlePause}
      onMouseUp={handleRestart}
    >
      <Button.Root
        onClick={onClickFooter}
        full
        variant="neutral-secondary"
        size="ml"
      >
        {buttonLabel === '' || !buttonLabel ? 'Button' : buttonLabel}
      </Button.Root>
    </div>
  )
}
